module.exports = __webpack_public_path__ + "static/f-icon2-20b571ccd1aa023b4bd7e118120f6620.svg";